import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

type ClarityArg = string | number | boolean | null | undefined;
type ClarityCall = (command: string, ...args: ClarityArg[]) => void;

declare global {
  interface Window {
    clarity?: ClarityCall;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
  private isInitialized = false;

  init(): void {
    if (this.isInitialized) {
      return;
    }
    if (!environment.clarity.enabled || !environment.clarity.projectId) {
      return;
    }
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    ((w: Window, l: Document, i: string) => {
      if (!w.clarity) {
        const clarityStub = ((...args: ClarityArg[]) => {
          (clarityStub as unknown as { q?: ClarityArg[][] }).q =
            (clarityStub as unknown as { q?: ClarityArg[][] }).q || [];
          (clarityStub as unknown as { q: ClarityArg[][] }).q.push(args);
        }) as ClarityCall;
        w.clarity = clarityStub;
      }
      const t = l.createElement('script');
      t.async = true;
      t.src = `https://www.clarity.ms/tag/${i}`;
      const y = l.getElementsByTagName('script')[0];
      y?.parentNode?.insertBefore(t, y);
    })(window, document, environment.clarity.projectId);

    this.isInitialized = true;
    this.setTag('tenant_key', environment.tenantKey);
    this.setTag('app_surface', 'web');
  }

  setTag(key: string, value: ClarityArg): void {
    if (!this.isInitialized || value == null || value === '') {
      return;
    }
    window.clarity?.('set', key, String(value));
  }
}

